export const isTownMarker = (marker) => {
    return 'image' in marker;
};
export const isDestinationMarker = (marker) => {
    return 'categories' in marker;
};
export const isTripMarker = (marker) => {
    return 'route' in marker;
};
